import { useFlags } from "launchdarkly-react-client-sdk";
import { ReactNode } from "react";

import type { SxProps } from "@mui/material/styles";
import { type Variant } from "@mui/material/styles/createTypography";

import { SUNO_DIALER_FEATURE } from "constants/feature-flags";
import { Patient } from "services/types/patients.type";
import { isNotBlank } from "utils/common";

import CallPatientLinkContent from "./call-patient-link-content.component";

type CallPatientLinkProps = {
  children: ReactNode;
  label?: ReactNode;
  patient?: Partial<Patient>;
  phoneNumber?: string | null;
  variant?: Variant;
  redirect?: boolean;
  sx?: SxProps;
  containerSx?: SxProps;
};
export default function CallPatientLink({
  patient,
  label,
  phoneNumber,
  variant,
  redirect,
  sx,
  containerSx,
  children
}: CallPatientLinkProps) {
  const flags = useFlags();
  const isSunoDialerEnabled = flags[SUNO_DIALER_FEATURE];

  if (!isSunoDialerEnabled) return <>{children}</>;

  const phone = [phoneNumber, patient?.phone, patient?.secondary_phone]
    .filter(isNotBlank)
    ?.at(0);

  if (!phone) return <>{children}</>;

  return (
    <CallPatientLinkContent
      label={label}
      phoneNumber={phone}
      patient={patient}
      variant={variant}
      redirect={redirect}
      sx={sx}
      containerSx={containerSx}
    />
  );
}
